<template>
  <div class="payorder-modal">
    <el-dialog
      :close-on-click-modal="false"
      :title="$t('bill.paying.title')"
      :visible="visible"
      width="650px"
      :before-close="handleClose"
    >
      <div class="payorder-content">
        <div class="paying-tit">{{$t('bill.paying.desc')}}</div>
        <p class="paying-des">
         {{$t('bill.paying.after')}}
        </p>
        <div class="loading-progress"></div>
        <div slot="footer" class="dialog-footer" style="text-align: right">
            <el-button type="primary" @click="handleClose">{{$t('bill.paying.success')}}</el-button>
            <el-button @click="goto">{{$t('bill.paying.failed')}}</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  inject:['reload'],
  data() {
    return {
      visible: false,
      orderSn: '',
      orderType: 'orders',
    };
  },
  watch: {

    visible: {
      handler(n, o) {
        this.visible = n;
      },
    },
  },
  props: {},
  methods: {
    handleClose() {
      this.visible = false;
      this.$emit('close');
      this.$router.go(0);
    },
    showChange() {
      this.visible = !this.visible;
    },
    Confirm() {
      this.visible = false;
    },
    goto() {
      this.$emit('close')
      this.handleClose()
      if(this.$route.fullPath == '/billing/index'){
        this.reload();
      } else{
        if(this.orderType == 'orders') {
          this.$router.push({
            path: "/billing/index",
            query: {
              type: 'order'
            },
          });
        }else {
          this.$router.push({
            path: "/billing/index",
          });
        }
      }
    },
  },
};
</script>

<style scoped lang="scss">
.payorder-modal {
  .payorder-content {
    padding-left: 20px;
    .paying-tit {
      height: 38px;
      line-height: 38px;
      font-size: 20px;
      color: #2d3137;
    }
    .paying-des {
      line-height: 26px;
      font-size: 16px;
      color: #5e6d81;
      margin-top: 10px;
      padding-bottom: 40px;
    }
  }
}
</style>
<style>
.payorder-modal .el-dialog__header {
  border-bottom: 0;
  /* display: none; */
}
.payorder-modal .el-dialog__header {
  border-bottom: 0;
  /* display: none; */
}
.payorder-modal .el-dialog__wrapper{
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.5);
  z-index: 100001 !important;

}


</style>




// WEBPACK FOOTER //
// src/components/payDialog/Paying.vue